import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import callBackendAPI from '../../utils/callBackendAPI';
import { toastDefaults } from '../../utils/ToastOptionCommon';
import { toast } from 'react-toastify';
import { recoverPasswordValidateSchema } from '../../utils/yupSchemas/ResgistrationSchema';
import { Button } from 'react-bootstrap';
import Busy from '../../assets/gif/busy.gif';
import FormikFormPasswordField from '../../utils/FormikPasswordField';
import { Base64 } from 'js-base64';
import { useNavigate, useParams } from 'react-router-dom';

const RecoverPassword = () => {
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);
      const response = await callBackendAPI(
        'POST',
        'auth/recoverPassword',
        null,
        {
          password: Base64.encode(values.password),
          id: params?.id,
        }
      );
      if (response.status === 200) {
        toast.success('Password reset successfully', toastDefaults());
        navigate('/');
      } else {
        toast.error(response?.error ?? 'Error occured', toastDefaults());
      }
    } catch (error) {
      toast.error('Error occured', toastDefaults());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout container py-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow-sm rounded-3 border-0">
            <div className="card-body p-4">
              <h2 className="text-center mb-4">Reset your password</h2>

              <Formik
                initialValues={{ password: '', confirmPassword: '' }}
                enableReinitialize
                validationSchema={recoverPasswordValidateSchema}
                onSubmit={(values) => handleSubmit(values)}
              >
                <Form>
                  {/* Password */}
                  <div className="mb-3">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                    >
                      New Password
                    </label>
                    <Field
                      id="password"
                      name="password"
                      type="password"
                      className="form-control"
                      placeholder="Enter new password"
                      as={FormikFormPasswordField}
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-3">
                    <label
                      htmlFor="confirmPassword"
                      className="form-label fw-semibold"
                    >
                      Confirm Password
                    </label>
                    <Field
                      id="confirmPassword"
                      name="confirmPassword"
                      type="password"
                      className="form-control"
                      placeholder="Re-enter new password"
                      as={FormikFormPasswordField}
                    />
                    <ErrorMessage
                      name="confirmPassword"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="d-grid mt-4">
                    <Button
                      type="submit"
                      className="btn btn-primary py-2"
                      disabled={loading}
                    >
                      {loading && (
                        <img
                          src={Busy}
                          alt="loading..."
                          className="me-2 mb-1"
                          style={{ maxWidth: '16px' }}
                        />
                      )}
                      Submit
                    </Button>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
